import React from 'react';
import CanvasElementContent from './CanvasElementContent';
import { PAGE_W, PAGE_H, normalizarCanvas } from './canvasUtils';

// Renderização somente-leitura do design livre: páginas A4 com elementos em
// posição absoluta. Usada no preview do editor e no modo leitura do painel.
// Envolver em <DocumentPreview> quando precisar escalar para caber no container.
export default function CanvasReadOnly({ proposta }) {
  const canvas = normalizarCanvas(proposta?.canvas);

  return (
    <div className="space-y-6">
      {canvas.paginas.map((pagina, pageIndex) => (
        <div
          key={pageIndex}
          className="relative shadow-lg rounded-sm overflow-hidden mx-auto"
          style={{ width: PAGE_W, height: PAGE_H, background: pagina.fundo_cor || '#ffffff' }}
        >
          {[...(pagina.elementos || [])]
            .sort((a, b) => (a.z || 0) - (b.z || 0))
            .map(elemento => (
              <div
                key={elemento.el_id}
                className="absolute"
                style={{
                  left: elemento.x,
                  top: elemento.y,
                  width: elemento.largura,
                  height: elemento.altura,
                  transform: elemento.rotacao ? `rotate(${elemento.rotacao}deg)` : undefined,
                  zIndex: elemento.z || 0,
                }}
              >
                <CanvasElementContent elemento={elemento} proposta={proposta} resolver />
              </div>
            ))}
        </div>
      ))}
    </div>
  );
}
